const Theme = {
  light: {
    backgroundColor: 'whitesmoke',
    color: '#000',
    primaryBackgroundColor: '#28235b',
    primaryBorderColor: '#28235b',
    primaryColor: '#fff',
    secondaryBackgroundColor: '#fff',
    secondaryBorderColor: '#e9ecef',
    secondaryColor: '#000',
    infoBackgroundColor: '#68159c',
    infoBorderColor: '#68159c',
    infoColor: '#fff',
    successBackgroundColor: '#03a099',
    successBorderColor: '#03a099',
    successColor: '#fff',
    warningBackgroundColor: '#dd5600',
    warningBorderColor: '#dd5600',
    warningColor: '#fff',
    dangerBackgroundColor: '#c71c22',
    dangerBorderColor: '#c71c22',
    dangerColor: '#fff',
    defaultBackgroundColor: '#fff',
    defaultBorderColor: '#fff',
    defaultColor: '#000',
    pageHeadingBackgroundColor: '#d8d8d8',
    pageHeadingColor: '#000',
    navBarBackgroundColor: '#28235b',
    navBarColor: '#fff',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    cardBackgroundColor: '#fff',
    cardBorder: '1px solid #e8e8e8',
    cardColor: 'rgba(0, 0, 0, 0.65)',
    calendarNavigationBackgroundColor: '#5a5656',
    calendarNavigationColor: '#fff',
    calendarNavigationBorder: '1px solid lightgrey',
    bottomNavigationBackgroundColor: '#fff',
    bottomNavigationColor: '#000',
    bottomNavigationActiveColor: '#6495ed',
    rowHoverBackgroundColor: '#c1c1c1',
    departmentCalendarHeadingBackgroundColor: '#f9f9f9',
    departmentCalendarHeadingColor: '#000'
  },
  dark: {
    backgroundColor: '#2f2f2f',
    color: '#fff',
    primaryBackgroundColor: '#2A9FD6',
    primaryBorderColor: '#2A9FD6',
    primaryColor: '#fff',
    secondaryBackgroundColor: '#555',
    secondaryBorderColor: '#555',
    secondaryColor: '#fff',
    infoBackgroundColor: '#9933CC',
    infoBorderColor: '#9933CC',
    infoColor: '#fff',
    successBackgroundColor: '#77B300',
    successBorderColor: '#77B300',
    successColor: '#fff',
    warningBackgroundColor: '#FF8800',
    warningBorderColor: '#FF8800',
    warningColor: '#fff',
    dangerBackgroundColor: '#CC0000',
    dangerBorderColor: '#CC0000',
    dangerColor: '#fff',
    defaultBackgroundColor: '#fff',
    defaultBorderColor: '#fff',
    defaultColor: '#000',
    pageHeadingBackgroundColor: '#000',
    pageHeadingColor: '#fff',
    navBarBackgroundColor: '#ae05d8',
    navBarColor: '#fff',
    boxShadow: 'none',
    cardBackgroundColor: '#444',
    cardBorder: 'none',
    cardColor: '#fff',
    calendarNavigationBackgroundColor: '#656565',
    calendarNavigationColor: '#fff',
    calendarNavigationBorder: '1px solid #7b7b7b',
    bottomNavigationBackgroundColor: '#000',
    bottomNavigationColor: '#929292',
    bottomNavigationActiveColor: '#fff',
    rowHoverBackgroundColor: '#848484',
    departmentCalendarHeadingBackgroundColor: '#f9f9f9',
    departmentCalendarHeadingColor: '#000'
  },
  custom: {
    backgroundColor: '#2B3E50',
    color: '#EBEBEB',
    primaryBackgroundColor: '#DF691A',
    primaryBorderColor: '#DF691A',
    primaryColor: '#fff',
    secondaryBackgroundColor: '#4E5D6C',
    secondaryBorderColor: '#4E5D6C',
    secondaryColor: '#fff',
    infoBackgroundColor: '#5893df',
    infoBorderColor: '#5893df',
    infoColor: '#fff',
    successBackgroundColor: '#115f11',
    successBorderColor: '#115f11',
    successColor: '#fff',
    warningBackgroundColor: '#ff8800',
    warningBorderColor: '#ff8800',
    warningColor: '#000',
    dangerBackgroundColor: '#90242f',
    dangerBorderColor: '#90242f',
    dangerColor: '#fff',
    defaultBackgroundColor: '#fff',
    defaultBorderColor: '#fff',
    defaultColor: '#000',
    pageHeadingBackgroundColor: '#4E5D6C',
    pageHeadingColor: '#fff',
    navBarBackgroundColor: '#DF691A',
    navBarColor: '#fff',
    boxShadow: 'none',
    cardBackgroundColor: '#4E5D6C',
    cardBorder: 'none',
    cardColor: '#fff',
    calendarNavigationBackgroundColor: '#797979',
    calendarNavigationColor: '#fff',
    calendarNavigationBorder: '1px solid #7b7b7b',
    bottomNavigationBackgroundColor: '#fff',
    bottomNavigationColor: '#000',
    bottomNavigationActiveColor: '#6495ed',
    rowHoverBackgroundColor: '#4e4e4e',
    departmentCalendarHeadingBackgroundColor: '#f9f9f9',
    departmentCalendarHeadingColor: '#000'
  }
};

export default Theme;

/*
const Theme = {
  light: {
    backgroundColor: '#eee',
    color: '#000',
    primaryBackgroundColor: '#9f7ce1',
    primaryBorderColor: '#9f7ce1',
    primaryColor: '#fff',
    secondaryBackgroundColor: '#fff',
    secondaryBorderColor: '#c4c4c4',
    secondaryColor: '#000',
    infoBackgroundColor: '#5893df',
    infoBorderColor: '#5893df',
    infoColor: '#fff',
    successBackgroundColor: '#115f11',
    successBorderColor: '#115f11',
    successColor: '#fff',
    warningBackgroundColor: '#ffc107',
    warningBorderColor: '#ffc107',
    warningColor: '#856404',
    dangerBackgroundColor: '#90242f',
    dangerBorderColor: '#90242f',
    dangerColor: '#fff',
    defaultBackgroundColor: '#fff',
    defaultBorderColor: '#fff',
    defaultColor: '#000',
    pageHeadingBackgroundColor: '#d8d8d8',
    pageHeadingColor: '#000',
    navBarBackgroundColor: '#246497',
    navBarColor: '#fff',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    cardBackgroundColor: '#fff',
    cardColor: '#000',
    calendarNavigationBackgroundColor: '#5a5656',
    calendarNavigationColor: '#fff',
    calendarNavigationBorder: '1px solid lightgrey'
  },
  dark: {
    backgroundColor: '#222',
    color: '#fff',
    primaryBackgroundColor: '#9f7ce1',
    primaryBorderColor: '#9f7ce1',
    primaryColor: '#fff',
    secondaryBackgroundColor: '#fff',
    secondaryBorderColor: '#fff',
    secondaryColor: '#000',
    infoBackgroundColor: '#5893df',
    infoBorderColor: '#5893df',
    infoColor: '#fff',
    successBackgroundColor: '#115f11',
    successBorderColor: '#115f11',
    successColor: '#fff',
    warningBackgroundColor: '#ff8800',
    warningBorderColor: '#ff8800',
    warningColor: '#000',
    dangerBackgroundColor: '#90242f',
    dangerBorderColor: '#90242f',
    dangerColor: '#fff',
    defaultBackgroundColor: '#fff',
    defaultBorderColor: '#fff',
    defaultColor: '#000',
    pageHeadingBackgroundColor: '#303030',
    pageHeadingColor: '#fff',
    navBarBackgroundColor: '#375a7f ',
    navBarColor: '#fff',
    boxShadow: 'none',
    cardBackgroundColor: '#444',
    cardColor: '#fff',
    calendarNavigationBackgroundColor: '#444',
    calendarNavigationColor: '#fff',
    calendarNavigationBorder: '1px solid #7b7b7b'
  }
};

export default Theme;
*/
